import { QueryClient } from "@tanstack/react-query";

// Single source of truth for invalidating all caches related to an
// application. Because the new summary / decision / per-applicant query
// keys are nested under ["APPLICATION", id, ...], a single invalidation
// of the ["APPLICATION", id] prefix cascades to all of them via React
// Query's hierarchical key matching.
export const invalidateApplicationQueries = (
  queryClient: QueryClient,
  applicationId: string | number
) => {
  const id = String(applicationId);
  queryClient.invalidateQueries({ queryKey: ["APPLICATION", id] });
  queryClient.invalidateQueries({ queryKey: ["APPLICANTS_TABLE"] });
};
